<div>
    <app-branch-list></app-branch-list>
</div>
<div>
    <app-branch-form></app-branch-form>
</div>